import { PageName } from '@/enums/pageName'

export const getPath = (pageName: PageName): string => {
  return `/${pageName}`
}

export const getPageName = (url: string): PageName => {
  return url.replace('/', '').replace('#', '') as PageName
}
